interface RoachPosterProps {
  accent?: string;
  compact?: boolean;
}

export function RoachPoster({ accent = '#a9ff3f', compact = false }: RoachPosterProps) {
  return (
    <svg class={`roach-poster${compact ? ' roach-poster--compact' : ''}`} viewBox="0 0 520 620" role="img" aria-label="Stylised cockroach illustration">
      <path class="poster-ray" d="M28 92 486 16 454 590 46 548Z" fill={accent} opacity=".12" />
      <g class="roach-art" fill="none" stroke="#151511" stroke-linecap="round" stroke-linejoin="round">
        <path d="M212 175C108 198 79 323 142 437c45 82 171 94 234 15 77-97 43-239-65-273-31-10-66-11-99-4Z" fill={accent} stroke-width="16" />
        <path d="M254 180c-42 66-52 211-6 310M201 202c36 23 77 25 120 2M166 279c59 30 133 31 203 0M150 371c73 29 153 31 233-2" stroke-width="11" opacity=".75" />
        <path d="M180 228 79 151M161 297 48 278M159 372 67 442M337 223l111-83M365 296l110-22M366 376l91 84" stroke-width="18" />
        <path d="m218 174-59-105M300 176 362 62" stroke-width="12" />
        <circle cx="216" cy="212" r="15" fill="#f0e5c8" stroke-width="8" />
        <circle cx="304" cy="211" r="15" fill="#f0e5c8" stroke-width="8" />
        <circle cx="216" cy="213" r="5" fill="#151511" stroke="none" />
        <circle cx="304" cy="212" r="5" fill="#151511" stroke="none" />
      </g>
      <path d="M24 565h470" stroke={accent} stroke-width="16" />
    </svg>
  );
}
